// ==============================|| OVERRIDES - GRID ||============================== //
// Corrige o Grid: a classe css-*-MuiGrid-root pode restringir a largura.
// Garante que containers ocupem 100% da largura disponível no dashboard.

export default function Grid() {
  return {
    MuiGrid: {
      styleOverrides: {
        root: {
          '&.MuiGrid-container': {
            width: '100%',
            maxWidth: '100%'
          }
        }
      }
    }
  };
}
